export const WELD_PRICING_URL = "https://weld.app/pricing";

export const WELD_PLAN_COMPARISON_TABLE_URL =
  "https://weld.app/pricing#comparison-table";
